import { EXPERIMENT_USE_CUSTOM_ROUTER } from '@wix/communities-blog-experiments';
import { navigateToBlogWithPostMessage, navigateToBlog } from '../services/navigate-to-section';
import { isExperimentEnabled } from '@wix/communities-blog-client-common/dist/src/selectors/experiments-selectors';

export const navigateToBlogSection = to => (dispatch, getState) => {
  const useCustomRouter = isExperimentEnabled(getState(), EXPERIMENT_USE_CUSTOM_ROUTER);
  (useCustomRouter ? navigateToBlogWithPostMessage : navigateToBlog)(to);
};
